export default {
	namespaced: true,
	state: {
		endpoint: '/document/property',
		name: 'DocumentProperty',
		title: {
			single: 'DocumentProperty',
			plural: 'DocumentPropertys'
		},
		icon: 'mdi-list-box',
		items: [],
		headers: [
			{ text: 'ID', value: 'id', sortable: true, width: '50' },
			{ text: 'Код', value: 'code', sortable: true },
			{ text: 'Назва', value: 'name', sortable: true },
			{ text: 'type', value: 'type.name', sortable: true},
			{ text: 'value', value: 'value', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true },
			{ text: 'actions', value: 'actions', sortable: false, width: '10%' },
		],
		item: {
			type: {},
		},
	},
	actions: {
		clearItem(context) {
			context.commit('item', {
				type: {},
			})
		},
	},
}
